/*
  SOV — Category Window (controller)
  Funzione: attende il payload facets root (via SOV.facets), genera card categorie e gestisce "Mostra altro".
  Requisiti: presente nel DOM <section id="sovCategoryWindow"> con .sov-cat-grid, .sov-cat-loading e bottone [data-action="show-more"].
  Link collezione: costruito da url_to_add rimuovendo eventuale param view=.
  -Ultimo aggiornamento: 2025-10-16 16:40 Europe/Rome
  prima: init in anticipo → nessun render
  dopo: listener robusto su sov:facets:root:ready + cache sync; zero fetch diretti
*/

(function () {
  'use strict';

  /* ============================
     Costanti
     ============================ */
  var MONOGRAM_URL = 'https://cdn.shopify.com/s/files/1/0938/3949/1420/files/sov-monogram-1-100.png?v=1761485809';

  // Numero di card “sopra la piega” trattate come prioritarie (hint eager + fetchpriority)
  var PRIORITY_VISIBLE_CARDS = 8;

  // Concorrenza massima per le fetch delle thumbs (valori più alti aumentano la pressione sulla rete)
  var CONCURRENCY_LIMIT = 4;

  // Le primissime card partono subito anche se si è già al limite (accorcia il time-to-first-thumb)
  var FASTLANE = 2;

  /* ============================
     Utility generiche
     ============================ */

  /* ============================
     Thumbs per categoria (view=sov-cat-thumbs.json)
     ============================ */
  var THUMBS_VIEW = 'sov-cat-thumbs.json';

  function upsertQueryParam(url, key, val) {
    try {
      var u = new URL(url, window.location.origin);
      if (val === null) u.searchParams.delete(key);
      else u.searchParams.set(key, val);
      return u.pathname + (u.search ? u.search : '');
    } catch (_) {
      var hasQ = url.indexOf('?') > -1;
      if (val === null) return url;
      return url + (hasQ ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(val);
    }
  }

  /* riscrive/aggiunge il parametro width=; clamp a 450px max */
  function rewriteWidthParam(url, w) {
    try {
      var maxW = 450;                  /* limite massimo */
      var ww = Math.min(maxW, (w | 0) || 0);
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(ww));
      return u.pathname + (u.search ? u.search : '');
    } catch (_) {
      var ww = Math.min(450, (w | 0) || 0);
      var hasQ = url.indexOf('?') > -1;
      var rx = /([?&])width=\d+/;
      if (rx.test(url)) return url.replace(rx, '$1width=' + String(ww));
      return url + (hasQ ? '&' : '?') + 'width=' + String(ww);
    }
  }

  function fetchRandomThumbForUrl(urlToAdd) {
    try {
      if (!urlToAdd) return Promise.resolve(null);
      var thumbsUrl = upsertQueryParam(urlToAdd, 'view', THUMBS_VIEW);
      thumbsUrl = upsertQueryParam(thumbsUrl, 'sort_by', 'created-descending');

      function pickOne(json) {
        var arr = Array.isArray(json && json.images) ? json.images : [];
        arr = arr.filter(function (it) { return it && it.src; });
        if (!arr.length) return null;
        var pick = arr[Math.floor(Math.random() * arr.length)];
        return {
          src: pick.src,
          srcset: pick.srcset || '',
          sizes: pick.sizes || '(min-width: 901px) 25vw, 50vw',
          alt: pick.alt || ''
        };
      }

      return fetch(thumbsUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : { images: [] }; })
        .then(pickOne)
        .catch(function () { return null; });
    } catch (_) { return Promise.resolve(null); }
  }

  /* Applica la thumb:
     - aggiunge un <img> vero (srcset/sizes) sopra il monogram
     - su onload rimuove il monogram per evitare flash
  */
  /* Applica la thumb:
     - aggiunge un <img> vero (srcset/sizes) sopra il monogram
     - su onload rimuove il monogram per evitare flash
     - gestisce eager e fetchpriority high tramite opzioni
  */
  function applyThumbToCard(cardEl, urlToAdd, opts) {
    try {
      if (!cardEl || !urlToAdd) return Promise.resolve();
      var media = cardEl.querySelector('.sov-cat-card__media');
      if (!media) return Promise.resolve();

      var options = opts || {};
      var eager = !!options.eager;
      var highPrio = !!options.priorityHigh;

      // Restituisce una Promise per permettere a chi chiama di gestire la concorrenza reale
      return fetchRandomThumbForUrl(urlToAdd).then(function (pick) {
        if (!pick || !pick.src) return;

        var picture = document.createElement('picture');

        /* desktop ≥1200px: 360/412/450 — sizes 25vw */
        var srcDesktop = [360, 412, 450]
          .map(function (w) { return rewriteWidthParam(pick.src, w) + ' ' + w + 'w'; })
          .join(', ');
        var sourceDesktop = document.createElement('source');
        sourceDesktop.setAttribute('media', '(min-width: 1200px)');
        sourceDesktop.setAttribute('sizes', '25vw');
        sourceDesktop.setAttribute('srcset', srcDesktop);
        picture.appendChild(sourceDesktop);

        /* tablet ≥750px: 360/412/450 — sizes 25vw sopra 901px, altrimenti 50vw */
        var srcTablet = [360, 412, 450]
          .map(function (w) { return rewriteWidthParam(pick.src, w) + ' ' + w + 'w'; })
          .join(', ');
        var sourceTablet = document.createElement('source');
        sourceTablet.setAttribute('media', '(min-width: 750px)');
        sourceTablet.setAttribute('sizes', '(min-width: 901px) 25vw, 50vw');
        sourceTablet.setAttribute('srcset', srcTablet);
        picture.appendChild(sourceTablet);

        /* mobile ≤749px: 210 — sizes 210px */
        var sourceMobile = document.createElement('source');
        sourceMobile.setAttribute('media', '(max-width: 749px)');
        sourceMobile.setAttribute('sizes', '210px');
        sourceMobile.setAttribute('srcset', rewriteWidthParam(pick.src, 210) + ' 210w');
        picture.appendChild(sourceMobile);

        /* fallback <img>: 210w */
        var img = document.createElement('img');
        img.className = 'sov-cat-card__img';
        img.src = rewriteWidthParam(pick.src, 210);
        img.alt = '';                 /* decorativa: label già presente */
        img.decoding = eager ? 'sync' : 'async';
        img.loading = eager ? 'eager' : 'lazy';

        /* priorità di fetch: high se prima card (eager) oppure entro il perimetro highPrio */
        if (eager || highPrio) {
          try { img.fetchPriority = 'high'; } catch (_) {}
          try { img.setAttribute('fetchpriority', 'high'); } catch (_) {}
          // micro-preload quando l'URL è noto: migliora la “rilevabilità nel documento iniziale”
          try {
            var l = document.createElement('link');
            l.rel = 'preload'; l.as = 'image';
            l.href = rewriteWidthParam(pick.src, 360);
            document.head.appendChild(l);
          } catch (_) {}
        }

// fade-out + rimozione del monogram senza CLS
function dropMono() {
  media.classList.add('has-img'); // attiva la transizione CSS
  var mono = media.querySelector('.sov-cat-card__monogram');
  if (!mono) return;
  const done = () => { mono.removeEventListener('transitionend', done); mono.remove(); };
  mono.addEventListener('transitionend', done);
  // fallback se la transition non scatta
  setTimeout(() => { if (mono && mono.parentNode) mono.parentNode.removeChild(mono); }, 240);
}

// gestisce anche immagini già in cache (evento load potrebbe non scattare)
if (img.complete && img.naturalWidth > 0) {
  dropMono();
} else {
  img.addEventListener('load', dropMono, { once: true });
}

picture.appendChild(img);


        /* pulizia e mount */
        media.querySelectorAll('picture, img.sov-cat-card__img').forEach(function (n) { n.remove(); });
        media.appendChild(picture);
      }).catch(function () { /* assorbe errori di rete */ });
    } catch (_) { return Promise.resolve(); }
  }

  /* Concorrenza limitata per non saturare la rete */
  function hydrateThumbsRange(ctx, startIndex, count) {
    var end = Math.min(startIndex + count, ctx.items.length);
    var i = startIndex, running = 0;

    function pump() {
      if (i >= end && running === 0) return;

      // Avvia nuove unità finché sotto il limite; in prima pagina consente FASTLANE
      while (
        i < end &&
        (running < CONCURRENCY_LIMIT || (startIndex === 0 && i < FASTLANE))
      ) {
        (function (idx) {
          running++;
          var card = ctx.grid.querySelectorAll('.sov-cat-card')[idx];
          var urlAdd = ctx.items[idx] && ctx.items[idx].urlToAdd;

          // Priorità: prime N card globali eager + fetchpriority high
          var eager = (idx < PRIORITY_VISIBLE_CARDS);
          var priorityHigh = (startIndex === 0) && (idx < (ctx.hpCount || 0));

          applyThumbToCard(card, urlAdd, { eager: eager, priorityHigh: priorityHigh })
            .finally(function () {
              running--;
              pump();
            });
        })(i++);
      }
    }
    pump();
  }

  function getRootSection() {
    // id statico; fallback al closest nel caso lo script venga incluso in bundle
    var el = document.getElementById('sovCategoryWindow');
    if (el) return el;
    try {
      var sc = document.currentScript;
      if (sc && sc.closest) return sc.closest('section.sov-category-window');
    } catch (_) {}
    return null;
  }

  function gtagSafe() {
    return (typeof window.gtag === 'function') ? window.gtag : null;
  }

  function buildFinalCollectionUrl(urlToAdd) {
    // rimuove "view=" dal link facet e restituisce il path/qs finale
    try {
      var u = new URL(urlToAdd, window.location.origin);
      u.searchParams.delete('view');
      return u.pathname + (u.search ? u.search : '');
    } catch (_) {
      // fallback robusto anche se URL non assoluto
      try {
        var hasQ = urlToAdd.indexOf('?') > -1;
        if (!hasQ) return urlToAdd || '#';
        var parts = urlToAdd.split('?');
        var qs = parts[1].replace(/(?:^|&)view=[^&]*/g, '').replace(/^&+|&+$/g, '');
        return parts[0] + (qs ? '?' + qs : '');
      } catch (e2) { return urlToAdd || '#'; }
    }
  }

  function findFilterByParamName(payload, paramName) {
    try {
      if (!payload || !Array.isArray(payload.filters)) return null;
      for (var i = 0; i < payload.filters.length; i++) {
        var f = payload.filters[i];
        if ((f && (f.param_name || '')) === paramName) return f;
      }
      return null;
    } catch (_) { return null; }
  }

  function extractCategoriesFromRoot(rootJson) {
    // Supporta sia schema .values che .items; filtra count>0; mappa {label,url}
    try {
      var catParam = (rootJson && rootJson.hints && rootJson.hints.category_param_name) || 'filter.p.t.category';
      var f = findFilterByParamName(rootJson, catParam);
      if (!f) return [];

      var src = Array.isArray(f.values) ? f.values : (Array.isArray(f.items) ? f.items : []);
      var out = [];
      for (var i = 0; i < src.length; i++) {
        var v = src[i] || {};
        var label = v.label || v.name || v.title || '';
        var urlAdd = v.url_to_add || v.url || v.href || '';
        var count = (v.count | 0) || (v.results_count | 0) || 0;
        if (!label || !urlAdd || count <= 0) continue;
        out.push({
          label: label,
          href: buildFinalCollectionUrl(urlAdd),
          urlToAdd: urlAdd,          // serve per il view sov-cat-thumbs.json
          count: count
        });
      }
      return out;
    } catch (_) { return []; }
  }

  /* ============================
     Render helpers
     ============================ */
  /* Crea una card categoria con media, label e pulsante wishlist collezione.
   Il bottone non interferisce con il click della card grazie alla delega in capture.
   -Ultimo aggiornamento: 2025-10-19 10:25 Europe/Rome
*/
function createCategoryCard(item, isPriority) {
  var li = document.createElement('li');
  li.className = 'sov-cat-grid__cell vignette';

  var a = document.createElement('a');
  a.className = 'sov-cat-card';
  a.href = item.href;
  a.setAttribute('data-url-add', item.urlToAdd || '');
  a.setAttribute('data-collection-href', item.href);
  a.setAttribute('data-collection-label', item.label || '');

  var media = document.createElement('div');
  media.className = 'sov-cat-card__media';

  var img = document.createElement('img');
  img.className = 'sov-cat-card__monogram';
  img.src = MONOGRAM_URL;
  img.width = 160;
  img.height = 160;
  img.alt = 'SOV';
  if (isPriority) {
    img.setAttribute('loading', 'eager');
    img.setAttribute('fetchpriority', 'high');
    img.setAttribute('decoding', 'sync');
  } else {
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
  }
  media.appendChild(img);

  /* Label */
  var label = document.createElement('div');
  label.className = 'sov-cat-card__label';
  var span = document.createElement('span');
  span.className = 'sov-cat-card__label-text';
  span.textContent = item.label;
  label.appendChild(span);

  

  a.appendChild(media);
  a.appendChild(label);
  
  var wl = document.createElement('div');
  wl.className = 'sov-wishlist-anchor';
  wl.innerHTML =
    '<button class="wishlist-btn sov-title-wishlist" data-collection-href="' + (item.href || '') + '" data-collection-label="' + (item.label || '') + '" aria-label="Add to wishlist">' +
      '<span class="wishlist-icon">' +
        '<svg class="wishlist-heart" viewBox="0 0 26 26" width="22" height="22" fill="none" stroke="#c29a37" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M12 21s-6.6-4.24-10-9.23C-1.05 6.04 2.61 2 6.84 2A5.57 5.57 0 0 1 12 5.09 5.57 5.57 0 0 1 17.16 2c4.23 0 7.89 4.04 4.84 9.77C18.6 16.76 12 21 12 21z"/>' +
        '</svg>' +
      '</span>' +
    '</button>';
  /* ancoraggio al media per usare l’assoluto del CSS */
  media.appendChild(wl);
  li.appendChild(a);
  return li;
}


  /* ============================
     Controller sezione
     ============================ */
  function hydrateFromRootPayload(rootJson, ctx) {
    try {
      if (!ctx || ctx.hydrated) return;

      var items = extractCategoriesFromRoot(rootJson);
if (!items.length) {
  try { removeSOVLoader(); } catch (_) {}
  if (ctx.root) ctx.root.classList.remove('is-hydrating');
  if (ctx.moreBtn) ctx.moreBtn.hidden = true;
  return;
}


      // ordina alfabetico (stesso comportamento del menu dinamico), si può cambiare se serve
      items.sort(function (a, b) { return (a.label || '').localeCompare(b.label || ''); });

      ctx.items = items;

      // render iniziale: min(initial, items.length)
      var n = Math.min(ctx.initial, items.length);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        // Card prioritarie: le prime righe visibili
        var isPriority = (i < PRIORITY_VISIBLE_CARDS);
        frag.appendChild(createCategoryCard(items[i], isPriority));
      }
      ctx.grid.appendChild(frag);

      // Idrata le thumbs con concorrenza reale limitata
      hydrateThumbsRange(ctx, 0, n);

      ctx.rendered = n;
      if (ctx.root) ctx.root.classList.remove('is-hydrating');
      try { removeSOVLoader(); } catch (_) {}
      toggleMoreVisibility(ctx);
      fireImpressionOnce(ctx);
      measureLcpSampled();
    } catch (_) {}
  }

  function appendMore(ctx) {
    var remain = ctx.items.length - ctx.rendered;
    if (remain <= 0) return;

    var n = Math.min(ctx.batch, remain);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      // “Mostra altro”: non prioritarie
      frag.appendChild(createCategoryCard(ctx.items[ctx.rendered + i], false));
    }
    ctx.grid.appendChild(frag);

    // idrata le nuove n card
    hydrateThumbsRange(ctx, ctx.rendered, n);

    ctx.rendered += n;

    toggleMoreVisibility(ctx);

    if (ctx.announcer) ctx.announcer.textContent = n + ' categorie caricate';

    var g = gtagSafe();
    if (g) g('event', 'category_show_more_click', { batch_added: n, total_rendered: ctx.rendered });
  }

function toggleMoreVisibility(ctx) {
  if (!ctx.moreBtn) return;
  ctx.moreBtn.hidden = !(ctx.rendered < ctx.items.length);
}


  function fireImpressionOnce(ctx) {
    if (ctx.impressed) return;
    ctx.impressed = true;
    var g = gtagSafe();
    if (g) g('event', 'category_window_impression', { items_initial: ctx.rendered });
  }

  /* ============================
     Boot con attesa facets
     ============================ */
  function bootOnce() {
    var root = getRootSection();
    if (!root || root.__sovCatWinBooted) return;
    root.__sovCatWinBooted = true;
    root.classList.add('is-hydrating'); // blocco layout semplice

    var grid = root.querySelector('.sov-cat-grid');    
    var moreBtn = root.querySelector('[data-action="show-more"]');
    if (moreBtn) moreBtn.hidden = true;
    var announcer = root.querySelector('#sovCatAnnouncer');

// loader ON
try { startSOVLoader(); } catch (_) {}

    var ctx = {
      root: root,
      grid: grid,      
      moreBtn: moreBtn,
      announcer: announcer,
      items: [],
      rendered: 0,
      impressed: false,
      hydrated: false,
      initial: parseInt(root.getAttribute('data-initial-count'), 10) || 8,
      batch: parseInt(root.getAttribute('data-batch-size'), 10) || 8,
      /* immagini con fetchpriority=high all'initial render */
      hpCount: Math.min(parseInt(root.getAttribute('data-initial-count'), 10) || 8, 8)
    };

    if (moreBtn) {
      moreBtn.addEventListener('click', function () { appendMore(ctx); });
    }

    function tryHydrateFromCache() {
      try {
        if (!(window.SOV && SOV.facets && typeof SOV.facets.getRootSync === 'function')) return false;
        var cached = SOV.facets.getRootSync();
        if (cached && Array.isArray(cached.filters)) {
          hydrateFromRootPayload(cached, ctx);
          ctx.hydrated = true;
          return true;
        }
      } catch (_) {}
      return false;
    }

function ensureNetworkAndHydrate() {
  try {
    if (!(window.SOV && SOV.facets && typeof SOV.facets.ensureRoot === 'function')) return;
    SOV.facets.ensureRoot()
      .then(function (json) {
        if (ctx.hydrated) return;
        hydrateFromRootPayload(json, ctx);
        ctx.hydrated = true;
      })
      .catch(function () {
        try { removeSOVLoader(); } catch (_) {}
        if (ctx.root) ctx.root.classList.remove('is-hydrating');
      });
  } catch (_) {
    try { removeSOVLoader(); } catch (__){}
    if (ctx.root) ctx.root.classList.remove('is-hydrating');
  }
}


    // 1) prova cache sync
    var got = tryHydrateFromCache();

    // 2) se non ottenuto, registra listener PRIMA di chiamare ensureRoot()
    if (!got) {
      document.addEventListener('sov:facets:root:ready', function (ev) {
        if (ctx.hydrated) return;
        var payload = ev && ev.detail && ev.detail.payload;
        if (payload && Array.isArray(payload.filters)) {
          hydrateFromRootPayload(payload, ctx);
          ctx.hydrated = true;
        }
      }, { once: true });

      // 3) avvia il fetch unico attraverso il distributore
      ensureNetworkAndHydrate();
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootOnce, { once: true });
    } else {
      bootOnce();
    }
    // hook anche agli eventi di sezione tipici di Shopify (editor)
    ['shopify:section:load', 'page:load'].forEach(function (ev) {
      document.addEventListener(ev, function () { bootOnce(); });
    });
  } catch (_) {}
})();
